import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import { getUserQuestionsById, updateUserQuestions } from '../../../../Adaptor/TUBSIS'
import { GetUserQuestionsByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Users/models/userModels'

type Props = { userId: number }

const PatientCourseQuestions: React.FC<Props> = ({ userId }) => {

    const [profession, setProfession] = useState<string | null>(null);
    const [martialStatus, setMartialStatus] = useState<number | null>(null);
    const [educationLevel, setEducationLevel] = useState<number | null>(null);
    const [livingPlaceStatus, setLivingPlaceStatus] = useState<number | null>(null);
    const [livingPlaceStatusDesc, setLivingPlaceStatusDesc] = useState<string | null>(null);
    const [ageOfAddiction, setAgeOfAddiction] = useState<number | null>(null);
    const [smokingQuitIsTry, setSmokingQuitIsTry] = useState<number | null>(null);
    const [smokingQuitTryCount, setSmokingQuitTryCount] = useState<number | null>(null);
    const [currentEducation, setCurrentEducation] = useState<number | null>(null);
    const [currentEducationDesc, setCurrentEducationDesc] = useState<string | null>(null);
    const [haveChild, setHaveChild] = useState<number | null>(null);
    const [currentJob, setCurrentJob] = useState<number | null>(null);
    const [currentJobDesc, setCurrentJobDesc] = useState<string | null>(null);
    const [motherEducationLevel, setMotherEducationLevel] = useState<number | null>(null);
    const [fatherEducationLevel, setFatherEducationLevel] = useState<number | null>(null);
    const [financialStatus, setFinancialStatus] = useState<number | null>(null);
    const [firstTryAge, setFirstTryAge] = useState<number | null>(null);
    const [lastConsumption, setLastConsumption] = useState<Date | null>(null);
    const [smokingBehavior, setSmokingBehavior] = useState<number | null>(null);
    const [smokingRoutine, setSmokingRoutine] = useState<number | null>(null);
    const [smokingRoutineCount, setSmokingRoutineCount] = useState<number | null>(null);
    const [questionEnSonBirakmaGirisimYil, setQuestionEnSonBirakmaGirisimYil] = useState<number | null>(null);
    const [questionEnSonBirakmaGirisimAy, setQuestionEnSonBirakmaGirisimAy] = useState<number | null>(null);
    const [questionEnSonBirakmaGirisimGun, setQuestionEnSonBirakmaGirisimGun] = useState<number | null>(null);
    const [questionEnUzunKullanmamaYil, setQuestionEnUzunKullanmamaYil] = useState<number | null>(null);
    const [questionEnUzunKullanmamaAy, setQuestionEnUzunKullanmamaAy] = useState<number | null>(null);
    const [questionEnUzunKullanmamaGun, setQuestionEnUzunKullanmamaGun] = useState<number | null>(null);
    const [questionEnUzunBirakmaGirisimYil, setQuestionEnUzunBirakmaGirisimYil] = useState<number | null>(null);
    const [questionEnUzunBirakmaGirisimAy, setQuestionEnUzunBirakmaGirisimAy] = useState<number | null>(null);
    const [questionEnUzunBirakmaGirisimGun, setQuestionEnUzunBirakmaGirisimGun] = useState<number | null>(null);

    const [isValidLastConsumption, setIsValidConsumption] = useState<boolean>(true);
    const [isValidAge, setIsValidAge] = useState<boolean>(true);
    const [isValidFirstTryAge, setIsValidFirstTryAge] = useState<boolean>(true);
    const [isValidSmokingRoutineCount, setIsValidSmokintRoutineCount] = useState<boolean>(true);

    const [isValidCurrentEducationDesc, setIsValidCurrentEducationDesc] = useState<boolean>(false);
    const [isValidLivingPlaceStatusDesc, setIsValidLivingPlaceStatusDesc] = useState<boolean>(false);
    const [isValidCurrentJobDesc, setIsValidCurrentJobDesc] = useState<boolean>(false);
    const [isValidSmokingQuitTryCount, setIsValidSmokingQuitTryCount] = useState<boolean>(false);
    const [isValidSmokingRoutine, setIsValidSmokingRoutine] = useState<boolean>(false);

    const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null)

    const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveAccordion(eventKey === activeAccordion ? null : eventKey)
    }

    const [userQuestions, setUserQuestions] = useState<GetUserQuestionsByIdOutput | null>(null)

    useEffect(() => {
        if (userId && userId > 0) {
            getUserQuestionsById(userId)
                .then((response) => {

                    setUserQuestions(response.data)
                    //console.log("userData", response.data)

                    setProfession(response.data?.profession ?? '')
                    setEducationLevel(response.data?.educationLevel ?? 9000)
                    setMartialStatus(response.data?.martialStatus ?? 11000)
                    setLivingPlaceStatus(response.data?.livingPlaceStatus ?? 14000)
                    setIsValidLivingPlaceStatusDesc(response.data?.livingPlaceStatus && response.data?.livingPlaceStatus === 14008 ? true : false)
                    setLivingPlaceStatusDesc(response.data?.livingPlaceStatusDesc ?? '')
                    setAgeOfAddiction(response.data?.ageOfAddiction ?? 0);
                    setCurrentEducation(response.data?.currentEducation ?? 10000)
                    setIsValidCurrentEducationDesc(response.data?.currentEducation && response.data?.currentEducation === 10008 ? true : false)
                    setCurrentEducationDesc(response.data?.currentEducationDesc ?? '')
                    setHaveChild(response.data?.haveChild ? 20003 : 20002);
                    setCurrentJob(response.data?.currentJob ?? 12000);
                    setIsValidCurrentJobDesc(response.data?.currentJob && response.data?.currentJob === 12006 ? true : false)
                    setCurrentJobDesc(response.data?.currentJobDesc ?? '')
                    setMotherEducationLevel(response.data?.motherEducationLevel ?? 9000);
                    setFatherEducationLevel(response.data?.fatherEducationLevel ?? 9000);
                    setFinancialStatus(response.data?.financialSituation ?? 13000);
                    setFirstTryAge(response.data?.firstTryAge ?? 0);
                    setLastConsumption(response.data?.lastConsumption ?? null);
                    setSmokingBehavior(response.data?.smokingBehavior ?? 18000);
                    setIsValidSmokingRoutine(response.data?.smokingBehavior && response.data?.smokingBehavior === 18002 ? true : false)
                    setSmokingRoutine(response.data?.smokingRoutine ?? 0)
                    setSmokingRoutineCount(response.data?.smokingRoutineCount ?? null)
                    setSmokingQuitIsTry(response.data?.smokingQuitIsTry ?? 0);
                    setIsValidSmokingQuitTryCount(response.data?.smokingQuitIsTry && response.data?.smokingQuitIsTry === 20003 ? true : false)
                    setSmokingQuitTryCount(response.data?.smokingQuitTryCount ?? 0)

                    if (response.data?.questionEnUzunBirakmaGirisim && response.data?.questionEnUzunBirakmaGirisim > 0) {

                        let enUzunGirisimCount = response.data?.questionEnUzunBirakmaGirisim;

                        const years = Math.floor(enUzunGirisimCount / 365);
                        const months = Math.floor((enUzunGirisimCount % 365) / 30);
                        const days = enUzunGirisimCount % 30;

                        setQuestionEnUzunBirakmaGirisimGun(days)
                        setQuestionEnUzunBirakmaGirisimAy(months)
                        setQuestionEnUzunBirakmaGirisimYil(years)
                    }
                    if (response.data?.questionEnSonBirakmaGirisim && response.data?.questionEnSonBirakmaGirisim > 0) {

                        let enSonGirisimCount = response.data?.questionEnSonBirakmaGirisim;

                        const years = Math.floor(enSonGirisimCount / 365);
                        const months = Math.floor((enSonGirisimCount % 365) / 30);
                        const days = enSonGirisimCount % 30;

                        setQuestionEnSonBirakmaGirisimGun(days)
                        setQuestionEnSonBirakmaGirisimAy(months)
                        setQuestionEnSonBirakmaGirisimYil(years)
                    }
                    if (response.data?.questionEnUzunKullanmama && response.data?.questionEnUzunKullanmama > 0) {

                        let enUzunKullanmamaCount = response.data?.questionEnUzunKullanmama;

                        const years = Math.floor(enUzunKullanmamaCount / 365);
                        const months = Math.floor((enUzunKullanmamaCount % 365) / 30);
                        const days = enUzunKullanmamaCount % 30;

                        setQuestionEnUzunKullanmamaGun(days)
                        setQuestionEnUzunKullanmamaAy(months)
                        setQuestionEnUzunKullanmamaYil(years)
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user:", error);
                });
        }

    }, [userId])

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'educationLevel') {
            setEducationLevel(parseInt(value));
        } else if (name === 'currentEducation') {
            setCurrentEducation(parseInt(value))
            if (parseInt(value) === 10008) {
                setIsValidCurrentEducationDesc(true)
            } else {
                setIsValidCurrentEducationDesc(false)
            }
        } else if (name === 'currentEducationDesc') {
            e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
            e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
            setCurrentEducationDesc(value)
        } else if (name === 'martialStatus') {
            setMartialStatus(parseInt(value))
        } else if (name === 'haveChild') {
            setHaveChild(parseInt(value))
        } else if (name === 'profession') {
            setProfession(value)
        } else if (name === 'currentJob') {
            setCurrentJob(parseInt(value))
            if (parseInt(value) === 12006) {
                setIsValidCurrentJobDesc(true)
            } else {
                setIsValidCurrentJobDesc(false)
            }
        } else if (name === 'currentJobDesc') {
            e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
            e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
            setCurrentJobDesc(value)
        } else if (name === 'livingPlaceStatus') {
            setLivingPlaceStatus(parseInt(value))
            if (parseInt(value) === 14008) {
                setIsValidLivingPlaceStatusDesc(true)
            } else {
                setIsValidLivingPlaceStatusDesc(false)
            }
        } else if (name === 'livingPlaceStatusDesc') {
            e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
            e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
            setLivingPlaceStatusDesc(value)
        } else if (name === 'motherEducationLevel') {
            setMotherEducationLevel(parseInt(value))
        } else if (name === 'fatherEducationLevel') {
            setFatherEducationLevel(parseInt(value))
        } else if (name === 'financialStatus') {
            console.log("fs", value)
            setFinancialStatus(parseInt(value))
        } else if (name === 'firstTryAge') {
            const pattern = /^(?:[1-9]|[1-9][0-9]?)?$/;
            setIsValidFirstTryAge(pattern.test(value));
            setFirstTryAge(parseInt(value))
        } else if (name === 'ageOfAddiction') {
            const pattern = /^(?:[1-9]|[1-9][0-9]?)?$/;
            setIsValidAge(pattern.test(value));
            setAgeOfAddiction(parseInt(value))
        } else if (name === 'lastConsumption') {
            const currentDate = new Date();
            const parsedDate = value ? new Date(value) : null;
            console.log("pd", parsedDate);

            // Gelecek bir tarih olmamalı
            const isValidConsumption = !parsedDate || parsedDate.getTime() <= currentDate.getTime();

            setLastConsumption(parsedDate);
            setIsValidConsumption(isValidConsumption);
        } else if (name === 'smokingBehavior') {
            setSmokingBehavior(parseInt(value))
            if (parseInt(value) === 18002) {
                setIsValidSmokingRoutine(true)
            } else {
                setIsValidSmokingRoutine(false)
            }
        } else if (name === 'smokingRoutine') {
            setSmokingRoutine(parseInt(value))
        } else if (name === 'smokingRoutineCount') {
            const pattern = /^(?:[1-9]|[1-9][0-9]?)?$/;
            setIsValidSmokintRoutineCount(pattern.test(value));
            setSmokingRoutineCount(parseInt(value))
        } else if (name === 'smokingQuitIsTry') {
            setSmokingQuitIsTry(parseInt(value))
            if (parseInt(value) === 20003) {
                setIsValidSmokingQuitTryCount(true)
            } else {
                setIsValidSmokingQuitTryCount(false)
            }
        } else if (name === 'smokingQuitTryCount') {
            setSmokingQuitTryCount(parseInt(value))
        } else if (name === 'questionEnSonBirakmaGirisimGun') {
            setQuestionEnSonBirakmaGirisimGun(parseInt(value))
        } else if (name === 'questionEnSonBirakmaGirisimAy') {
            setQuestionEnSonBirakmaGirisimAy(parseInt(value))
        } else if (name === 'questionEnSonBirakmaGirisimYil') {
            setQuestionEnSonBirakmaGirisimYil(parseInt(value))
        } else if (name === 'questionEnUzunKullanmamaGun') {
            setQuestionEnUzunKullanmamaGun(parseInt(value))
        } else if (name === 'questionEnUzunKullanmamaAy') {
            setQuestionEnUzunKullanmamaAy(parseInt(value))
        } else if (name === 'questionEnUzunKullanmamaYil') {
            setQuestionEnUzunKullanmamaYil(parseInt(value))
        } else if (name === 'questionEnUzunBirakmaGirisimGun') {
            setQuestionEnUzunBirakmaGirisimGun(parseInt(value))
        } else if (name === 'questionEnUzunBirakmaGirisimAy') {
            setQuestionEnUzunBirakmaGirisimAy(parseInt(value))
        } else if (name === 'questionEnUzunBirakmaGirisimYil') {
            setQuestionEnUzunBirakmaGirisimYil(parseInt(value))
        } else {
            console.log("bfs", value, name)
        }
    };

    const calculateTotalDays = (years: number | null, months: number | null, days: number | null) => {

        let totalDays = 0;

        if (years) {
            totalDays = totalDays + years * 365
        }
        if (months) {
            totalDays = totalDays + months * 30
        }
        if (days) {
            totalDays = totalDays + days
        }

        return totalDays;
    };

    const handleUpdate = async () => {
        // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
        // console.log("Form verileri güncellendi:", userData);

        if (!isValidAge || !isValidFirstTryAge || !isValidLastConsumption) {
            return;
        }

        let parsedLastConsumption = lastConsumption ? new Date(lastConsumption) : new Date(0)
        parsedLastConsumption.setHours(parsedLastConsumption.getHours() + 3)

        const questionEnUzunKullanmama = calculateTotalDays(questionEnUzunKullanmamaYil, questionEnUzunKullanmamaAy, questionEnUzunKullanmamaGun);
        const questionEnSonBirakmaGirisim = calculateTotalDays(questionEnSonBirakmaGirisimYil, questionEnSonBirakmaGirisimAy, questionEnSonBirakmaGirisimYil);
        const questionEnUzunBirakmaGirisim = calculateTotalDays(questionEnUzunBirakmaGirisimYil, questionEnUzunBirakmaGirisimAy, questionEnUzunBirakmaGirisimGun);

        const requestModel = {
            userId: userId,
            educationLevel: educationLevel ?? 9000,
            currentEducation: currentEducation ?? 10000,
            currentEducationDesc: currentEducationDesc && currentEducation === 10008 ? currentEducationDesc : "",
            haveChild: haveChild && haveChild === 20003 ? true : false,
            martialStatus: martialStatus ?? 11000,
            profession: profession ?? "",
            currentJob: currentJob ?? 12000,
            currentJobDesc: currentJobDesc && currentJob === 12006 ? currentJobDesc : "",
            financialSituation: financialStatus ?? 13000,
            motherEducationLevel: motherEducationLevel ?? 9000,
            fatherEducationLevel: fatherEducationLevel ?? 9000,
            livingPlaceStatus: livingPlaceStatus ?? 14000,
            livingPlaceStatusDesc: livingPlaceStatusDesc && livingPlaceStatus === 14008 ? livingPlaceStatusDesc : "",
            firstTryAge: firstTryAge ?? 0,
            ageOfAddiction: ageOfAddiction ?? 0,
            lastConsumption: new Date(parsedLastConsumption),
            smokingBehavior: smokingBehavior ?? 18000,
            smokingRoutine: smokingRoutine ?? 19000,
            smokingRoutineCount: smokingRoutineCount ?? 0,
            smokingQuitIsTry: smokingQuitIsTry ?? 20000,
            smokingQuitTryCount: smokingQuitTryCount && smokingQuitIsTry === 20003 ? smokingQuitTryCount : 0,
            questionEnUzunKullanmama: questionEnUzunKullanmama,
            questionEnSonBirakmaGirisim: questionEnSonBirakmaGirisim,
            questionEnUzunBirakmaGirisim: questionEnUzunBirakmaGirisim
        }

        const response = await updateUserQuestions(requestModel);

        if (response.success) {
            alert(response.message)
        } else {
            alert(response.message)
        }

        // window.location.reload()
    }

    return (
        <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
            <Card key={1}>
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Button
                            className='d-flex justify-content-between align-items-center w-100'
                            variant='link'
                            onClick={(e) => toggleAccordion('index.toString()', e)}
                        >
                            <div className='text-left text-gray-700'>TÜBSİS&POLSİS SORULARI</div>
                        </Button>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={'index.toString()'}>
                    <Card.Body>
                        <Form onSubmit={handleUpdate}>
                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Eğitim Düzeyi</Form.Label>
                                    <Form.Select
                                        name='educationLevel'
                                        value={educationLevel ?? 9000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='9000'>Seçiniz</option>
                                        <option value='9001'>Lisansüstü Mezunu</option>
                                        <option value='9002'>Lisans Mezunu</option>
                                        <option value='9003'>Önlisans Mezunu</option>
                                        <option value='9004'>Lise Mezunu</option>
                                        <option value='9005'>Ortaokul Mezunu</option>
                                        <option value='9006'>İlkokul Mezunu</option>
                                        <option value='9008'>Okur/Yazar Değil</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Devam Edilen Eğitim Programı</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        <Form.Select
                                            className='me-2'
                                            name='currentEducation'
                                            value={currentEducation ?? 10000}
                                            onChange={handleItemChange}
                                        >
                                            <option value='10000'>Seçiniz</option>
                                            <option value='10001'>Öğrenci Değilim</option>
                                            <option value='10002'>Lisansüstü</option>
                                            <option value='10003'>Lisans</option>
                                            <option value='10004'>Önlisans</option>
                                            <option value='10005'>Lise</option>
                                            <option value='10006'>Ortaokul</option>
                                            <option value='10007'>İlkokul</option>
                                            <option value='10008'>Diğer</option>
                                        </Form.Select>
                                        {isValidCurrentEducationDesc ? (
                                            <Form.Control
                                                type='textarea'
                                                as='textarea'
                                                placeholder='Lütfen belirtiniz...'
                                                name='currentEducationDesc'
                                                value={currentEducationDesc ?? ''}
                                                onChange={handleItemChange}
                                                hidden={!isValidCurrentEducationDesc}
                                            />
                                        ) : (
                                            <Form.Control
                                                type='text'
                                                readOnly
                                                style={{ border: "none" }}
                                            />
                                        )}
                                    </Form.Group>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Medeni Durumu</Form.Label>
                                    <Form.Select
                                        name='martialStatus'
                                        value={martialStatus ?? 11000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='11000'>Seçiniz</option>
                                        <option value='11001'>Bekar</option>
                                        <option value='11002'>Evli</option>
                                        <option value='11003'>Boşanmış</option>
                                        <option value='11005'>Ayrı</option>
                                        <option value='11004'>Dul (eşi vefat etmiş)</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Çocuğu Var Mı</Form.Label>
                                    <Form.Select
                                        name='haveChild'
                                        value={haveChild ?? 20000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='20000'>Seçiniz</option>
                                        <option value='20002'>Hayır</option>
                                        <option value='20003'>Evet</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Meslek</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        <Form.Control
                                            type='text'
                                            placeholder='Lütfen belirtiniz...'
                                            name='profession'
                                            value={profession ?? ''}
                                            onChange={handleItemChange}
                                        />
                                    </Form.Group>
                                </Form.Group>
                                <Form.Group as={Col}>

                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Düzenli İşi Var Mı? Varsa, Çalıştığı Son Pozisyon</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        {/* güncel işinizdeki ya da */}
                                        <Form.Select
                                            className='me-2'
                                            name='currentJob'
                                            value={currentJob ?? 12000}
                                            onChange={handleItemChange}
                                        >
                                            <option value='12000'>Seçiniz</option>
                                            <option value='12001'>Düzenli işim yok</option>
                                            <option value='12002'>Memur</option>
                                            <option value='12003'>İşçi</option>
                                            <option value='12004'>Emekli</option>
                                            <option value='12005'>İşveren</option>
                                            <option value='12006'>Diğer</option>
                                        </Form.Select>
                                        {isValidCurrentJobDesc ? (
                                            <Form.Control
                                                type='textarea'
                                                as='textarea'
                                                placeholder='Lütfen belirtiniz...'
                                                name='currentJobDesc'
                                                value={currentJobDesc ?? ''}
                                                onChange={handleItemChange}
                                                hidden={!isValidCurrentJobDesc}
                                            />
                                        ) : (
                                            <Form.Control
                                                type='text'
                                                readOnly
                                                style={{ border: "none" }}
                                            />
                                        )}
                                    </Form.Group>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Kiminle Yaşıyor</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        <Form.Select
                                            className='me-2'
                                            name='livingPlaceStatus'
                                            value={livingPlaceStatus ?? 14000}
                                            onChange={handleItemChange}
                                        >
                                            <option value='14000'>Seçiniz</option>
                                            <option value='14001'>Yurtta tek başıma</option>
                                            <option value='14002'>Yurtta arkadaşımla</option>
                                            <option value='14003'>Evde tek başıma</option>
                                            <option value='14004'>Evde arkadaşımla</option>
                                            <option value='14005'>Evde eşim ve (varsa) çocuklarımla</option>
                                            <option value='14006'>Evde annem/babam/kardeşimle</option>
                                            <option value='14007'>Evde akrabamla</option>
                                            <option value='14008'>Diğer</option>
                                        </Form.Select>
                                        {isValidLivingPlaceStatusDesc ? (
                                            <Form.Control
                                                type='textarea'
                                                as='textarea'
                                                placeholder='Lütfen belirtiniz...'
                                                name='livingPlaceStatusDesc'
                                                value={livingPlaceStatusDesc ?? ''}
                                                onChange={handleItemChange}
                                                hidden={!isValidLivingPlaceStatusDesc}
                                            />
                                        ) : (
                                            <Form.Control
                                                type='text'
                                                readOnly
                                                style={{ border: "none" }}
                                            />
                                        )}
                                    </Form.Group>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Anne Eğitim Düzeyi</Form.Label>
                                    <Form.Select
                                        name='motherEducationLevel'
                                        value={motherEducationLevel ?? 9000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='9000'>Seçiniz</option>
                                        <option value='9001'>Lisansüstü Mezunu</option>
                                        <option value='9002'>Lisans Mezunu</option>
                                        <option value='9003'>Önlisans Mezunu</option>
                                        <option value='9004'>Lise Mezunu</option>
                                        <option value='9005'>Ortaokul Mezunu</option>
                                        <option value='9006'>İlkokul Mezunu</option>
                                        <option value='9007'>Okur/Yazar</option>
                                        <option value='9008'>Okur/Yazar Değil</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>

                                </Form.Group>
                            </Row>
                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Baba Eğitim Düzeyi</Form.Label>
                                    <Form.Select
                                        name='fatherEducationLevel'
                                        value={fatherEducationLevel ?? 9000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='9000'>Seçiniz</option>
                                        <option value='9001'>Lisansüstü Mezunu</option>
                                        <option value='9002'>Lisans Mezunu</option>
                                        <option value='9003'>Önlisans Mezunu</option>
                                        <option value='9004'>Lise Mezunu</option>
                                        <option value='9005'>Ortaokul Mezunu</option>
                                        <option value='9006'>İlkokul Mezunu</option>
                                        <option value='9007'>Okur/Yazar</option>
                                        <option value='9008'>Okur/Yazar Değil</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>

                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Aylık Gelir Durumu</Form.Label>
                                    <Form.Select
                                        name='financialStatus'
                                        value={financialStatus ?? 13000}
                                        onChange={handleItemChange}
                                    >
                                        <option value='13000'>Seçiniz</option>
                                        <option value='13001'>Çok Düşük</option>
                                        <option value='13002'>Düşük</option>
                                        <option value='13003'>Orta</option>
                                        <option value='13004'>Yüksek</option>
                                        <option value='13005'>Çok Yüksek</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>İlk Kez Sigara Deneme Yaşı</Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder='... yaşındaydım'
                                        name='firstTryAge'
                                        value={!firstTryAge || firstTryAge === 0 ? '' : firstTryAge}
                                        onChange={handleItemChange}
                                        isInvalid={!isValidFirstTryAge}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Lütfen sayı girişi yapınız.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col}>

                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Düzenli Sigara Kullanmaya Başladığı Yaşı</Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder='... yaşındaydım'
                                        name='ageOfAddiction'
                                        value={!ageOfAddiction || ageOfAddiction === 0 ? '' : ageOfAddiction}
                                        onChange={handleItemChange}
                                        isInvalid={!isValidAge}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Lütfen sayı girişi yapınız.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>En Son Sigara İçme Tarihi (Bir Defa İçine Çekmek Dahil)</Form.Label>
                                    <FormControl
                                        type='date'
                                        name='lastConsumption'
                                        isInvalid={!isValidLastConsumption}
                                        value={lastConsumption ? new Date(lastConsumption).toISOString().split('T')[0] : ''}
                                        onChange={handleItemChange}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        Geçerli bir tarih ve saat girin.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col}>

                                </Form.Group>
                            </Row>
                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>En Uygun Sigara İçme Davranışını Seçiniz</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        <Form.Select
                                            className='me-2'
                                            name='smokingBehavior'
                                            value={smokingBehavior ?? 18000}
                                            onChange={handleItemChange}
                                        >
                                            <option value='18000'>Seçiniz</option>
                                            <option value='18001'>
                                                Düzenli olarak sigara içerim (haftada en az 3 adet)
                                            </option>
                                            <option value='18002'>
                                                Ara sıra sigara içerim (haftada 2 ve üzeri)
                                            </option>
                                            <option value='18003'>Önceden sigara içerdim.</option>
                                            <option value='18004'>
                                                Yaşamım boyunca en fazla birkaç kere denedim.
                                            </option>
                                        </Form.Select>
                                        {isValidSmokingRoutine ? (
                                            <>
                                                <Form.Select
                                                    className='me-2'
                                                    name='smokingRoutine'
                                                    value={smokingRoutine ?? 19000}
                                                    onChange={handleItemChange}
                                                    hidden={!isValidSmokingRoutine}
                                                >
                                                    <option value='19000'>Seçiniz</option>
                                                    <option value='19001'>Ayda</option>
                                                    <option value='19002'>Haftada</option>
                                                    <option value='19003'>Günde</option>
                                                </Form.Select>
                                                <Form.Control
                                                    type='text'
                                                    placeholder='... adet sigara içerim'
                                                    name='smokingRoutineCount'
                                                    value={!smokingRoutineCount || smokingRoutineCount === 0 ? '' : smokingRoutineCount}
                                                    onChange={handleItemChange}
                                                    isInvalid={!isValidSmokingRoutine}
                                                />
                                            </>
                                        ) : (
                                            <Form.Control
                                                className='me-2'
                                                type='text'
                                                readOnly
                                                style={{ border: "none" }}
                                            />
                                        )}
                                    </Form.Group>
                                </Form.Group>
                                <Form.Group as={Col}>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Form.Label>Hiç Sigarayı Bırakma Girişimi Olmuş Mu?</Form.Label>
                                    <Form.Group className='d-flex align-items-center'>
                                        <Form.Select
                                            className='me-2'
                                            name='smokingQuitIsTry'
                                            value={smokingQuitIsTry ?? 20000}
                                            onChange={handleItemChange}
                                        >
                                            <option value='20000'>Seçiniz</option>
                                            <option value='20002'>Hayır</option>
                                            <option value='20003'>Evet</option>
                                        </Form.Select>
                                        {isValidSmokingQuitTryCount ? (
                                            <Form.Control
                                                type='text'
                                                placeholder='... kere denedim/bıraktım.'
                                                name='smokingQuitTryCount'
                                                value={!smokingQuitTryCount || smokingQuitTryCount === 0 ? '' : smokingQuitTryCount}
                                                onChange={handleItemChange}
                                            // hidden={!isValidSmokingQuitTryCount}
                                            />
                                        ) : (
                                            <Form.Control
                                                type='text'
                                                readOnly
                                                style={{ border: "none" }}
                                            />
                                        )}
                                    </Form.Group>
                                </Form.Group>
                            </Row>
                            {isValidSmokingQuitTryCount ? (
                                <>
                                    <Row className='mb-3'>
                                        <Form.Group as={Col}>
                                            <Form.Label>Sigarayı Bırakmaya Yönelik Son Girişimde Ne Kadar süre Sigara İçmemiş?</Form.Label>
                                            <Form.Group className="d-flex align-items-center">
                                                <Form.Select
                                                    className="me-2"
                                                    name='questionEnSonBirakmaGirisimGun'
                                                    value={questionEnSonBirakmaGirisimGun ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Gün</option>
                                                    {Array.from({ length: 30 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select className="me-2"
                                                    name='questionEnSonBirakmaGirisimAy'
                                                    value={questionEnSonBirakmaGirisimAy ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Ay</option>
                                                    {Array.from({ length: 11 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select
                                                    name='questionEnSonBirakmaGirisimYil'
                                                    value={questionEnSonBirakmaGirisimYil ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Yıl</option>
                                                    {Array.from({ length: 99 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Form.Group>
                                        <Form.Group as={Col}>

                                        </Form.Group>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Form.Group as={Col}>
                                            <Form.Label>Sigara Kullanmaya Başladıktan Sonra En Uzun Ne Kadar Süre Hiç Sigara Kullanmamış?</Form.Label>
                                            <Form.Group className="d-flex align-items-center">
                                                <Form.Select className="me-2"
                                                    name='questionEnUzunKullanmamaGun'
                                                    value={questionEnUzunKullanmamaGun ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Gün</option>
                                                    {Array.from({ length: 30 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select className="me-2"
                                                    name='questionEnUzunKullanmamaAy'
                                                    value={questionEnUzunKullanmamaAy ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Ay</option>
                                                    {Array.from({ length: 11 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select
                                                    name='questionEnUzunKullanmamaYil'
                                                    value={questionEnUzunKullanmamaYil ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Yıl</option>
                                                    {Array.from({ length: 99 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Form.Group>
                                        <Form.Group as={Col}>

                                        </Form.Group>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Form.Group as={Col}>
                                            <Form.Label>Yaşamı Boyunca En Uzun Süreli Sigara Bırakma Girişimi Ne Kadar Sürdü?</Form.Label>
                                            <Form.Group className="d-flex align-items-center">
                                                <Form.Select className="me-2"
                                                    name='questionEnUzunBirakmaGirisimGun'
                                                    value={questionEnUzunBirakmaGirisimGun ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Gün</option>
                                                    {Array.from({ length: 30 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select className="me-2"
                                                    name='questionEnUzunBirakmaGirisimAy'
                                                    value={questionEnUzunBirakmaGirisimAy ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Ay</option>
                                                    {Array.from({ length: 11 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Select
                                                    name='questionEnUzunBirakmaGirisimYil'
                                                    value={questionEnUzunBirakmaGirisimYil ?? ''}
                                                    hidden={!isValidSmokingQuitTryCount}
                                                    onChange={handleItemChange}>
                                                    <option value="">Yıl</option>
                                                    {Array.from({ length: 99 }, (_, index) => (
                                                        <option key={index + 1} value={index + 1}>{index + 1}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label></Form.Label>
                                        </Form.Group>
                                    </Row>
                                </>
                            ) : (
                                <Form.Control
                                    type='text'
                                    readOnly
                                    style={{ border: "none" }}
                                />
                            )}

                            <Row className='mb-3'>
                                <Form.Group as={Col}>
                                    <Button variant='primary' onClick={handleUpdate}>
                                        Kaydet
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default PatientCourseQuestions
